import axios from "axios"
// import fs from "@/services/FormatService"
// import _ from "lodash"

export default {
	getPitches() {
		return axios.get(`/v1/pitches`)
	},

	pitches: [
		{
			id: "101",
			assignment_id: "5f18b17ac3d5a217c1933570",
			team_id: "5f0e25cac3d5a26144efda73",
			created_at: "2020-07-17T15:12:39.339+0000",
			team: {
				name: "Robots",
				students: [
					{ name: { first: "William", last: "Kerr" } },
					{ name: { first: "Miles", last: "Loring" } }
				]
			},
			thumbnail: "http://i3.ytimg.com/vi/BCkwsPk8wKM/hqdefault.jpg",
			url: "https://www.youtube.com/watch?v=BCkwsPk8wKM&feature=emb_title"
		},
		{
			id: "102",
			assignment_id: "5f18b17ac3d5a217c1933570",
			team_id: "5f0e26bbc3d5a26144efda74",
			created_at: "2020-07-18T15:12:39.339+0000",
			team: {
				name: "Non-Robots",
				students: [
					{ name: { first: "Zac", last: "Henrich" } },
					{ name: { first: "Miles", last: "Loring" } }
				]
			},
			thumbnail: "http://i3.ytimg.com/vi/Gpr_ISfWFsk/hqdefault.jpg"
		},
		{
			id: "103",
			assignment_id: "5f18b17ac3d5a217c1933570",
			created_at: "2020-07-19T15:12:39.339+0000",
			team: { name: "Solar Power" },
			students: [
				{ name: { first: "William", last: "Kerr" } },
				{ name: { first: "Zac", last: "Henrich" } }
			],

		},
	],

	getContextPitches() {
		return axios.get(`/v1/context/pitches`)
		// return fs.mockAPIResponse(this.pitches)
	},

	getContextPitchesPrefilled() {
		return axios.get(`/v1/context/pitches/prefilled`)
		// return fs.mockAPIResponse(this.pitches)
	},

	getSectionPitchesPrefilled(sectionID) {
		return axios.get(`/v1/section/pitches/prefilled/${sectionID}`)
		// return fs.mockAPIResponse(this.pitches)
	},

	getPitch(pitchID) {
		return axios.get(`/v1/pitch/${pitchID}`)
		// let pitch = _.find(this.pitches, { id: pitchID })
		// return fs.mockAPIResponse(pitch)
	},

	deletePitch(pitchID) {
		return axios.delete(`/v1/pitch/${pitchID}`)
	},

	getContextPitch(teamID, assignmentID) {
		return axios.get(`/v1/context/pitch/${teamID}/${assignmentID}`)
	},

	submitPitchYoutube(teamID, assignmentID, youtubeID) {
		return axios.post(`/v1/pitch/youtube/${teamID}/${assignmentID}/${youtubeID}`)
	},

	initUpload(data) {
		return axios.post(`/v1/pitch/init`, data)
	},

	uploadChunk(data) {
		return axios.post(`/v1/pitch/chunk`, data)
	},

	uploadSuccess(teamID, assignmentID, data) {
		console.log("TEAM ID", teamID)
		console.log("ASSIGNMENT ID", assignmentID)
		console.log("DATA", data)
		return axios.post(`/v1/pitch/success/${teamID}/${assignmentID}`, data)
	},

	uploadFailure(data) {
		return axios.post(`/v1/pitch/failure`, data)
	},

	saveDescription(teamID, assignmentID, text) {
		return axios.post(`/v1/pitch/description/${teamID}/${assignmentID}`, {
			"text": text
		})
	},

	getContextFeedbackCounts() {
		return axios.get(`/v1/context/pitch_feedback_counts`)
	},

	submitFeedback(feedback) {
		return axios.post(`/v1/submit/pitch_feedback`, feedback)
	},

	getMyFeedbacks() {
		return axios.get(`/v1/my/pitch_feedbacks`)
	},

	getUserFeedbacks(userID, sectionID) {
		return axios.get(`/v1/pitch_feedbacks/user/${userID}/${sectionID}`)
	},

	getSectionFeedbacks(sectionID) {
		return axios.get(`/v1/pitch_feedbacks/section/${sectionID}`)
	},

	getPitchFeedbacks(teamID) {
		return axios.get(`/v1/context/pitch_feedbacks/${teamID}`)
	},

	getPitchFeedbacksPrefilled(teamID) {
		return axios.get(`/v1/context/pitch_feedbacks/${teamID}/prefilled`)
	},

	getAllFeedbacksPrefilled() {
		return axios.get(`/v1/context/pitch_feedback/feedbacks/prefilled`)
	},

	deletePitchFeedbacks(teamID, assignmentID) {
		return axios.delete(`/v1/pitch_feedbacks/${teamID}/${assignmentID}`)
	},

	deletePitchFeedback(feedbackID) {
		return axios.delete(`/v1/pitch_feedback/${feedbackID}`)
	}
}
